import { AxiosResponse } from "axios"
import { requestApp, WEB_TO_APP } from "common/webview";

export type PromiseOptions = {
    more?: string,
}

export const onPromise = (self: any) => {
    return async (
        promise: (props?: any) => Promise<AxiosResponse>,
        options?: PromiseOptions,
    ): Promise<any> => {
        const more = options?.more || undefined;
        const loadingTimer = setTimeout(() => {
            requestApp(WEB_TO_APP.LOADING, {isLoading: true});
        }, 500);

        self.onPending();

        const { status, data, headers } = await promise();

        //READY
        if(status === 200 || status === 201 || status === 204) {
            // more 지정 시 기존 목록에 이어붙인다(무한 스크롤/더보기).
            // onReady 를 함께 호출하면 누적분이 이번 페이지로 덮어써지므로 분기해야 한다.
            if (more) {
                self.onMore(data, more, headers);
            } else {
                self.onReady(data, headers);
            }
        }

        //ERROR
        else {
            self.onError({...data, status}, headers);
        }
        
        clearTimeout(loadingTimer);
        requestApp(WEB_TO_APP.LOADING, {isLoading: false});
    }

}